import React from 'react'
import { connect } from 'react-redux'
import { ContentHeader, StaticBox, FlowTable } from 'components/basic'
import FlowView from 'components/core/FlowView'
import { notify } from 'helpers'
import http from 'API/http'

class OrderEventsOverview extends FlowView {
  constructor (props) {
    super(props)
    this.state = {
      events: []
    }
  }
  async componentDidMount () {
    var err, res
    [err, res] = await http.get('2.3/orderevents/latest')
    if (err) return notify.alert('', err.cause, 'error')
    this.setState({events: res.data})
    console.log(res.data)
  }

  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Events' subtitle='Log' icon='fa-sliders' />
        <hr />
        <div className='row'>
          <StaticBox cols={12} icon='sliders' title='Events'>
            <FlowTable paginatable={20} data={
                this.state.events.map(event => [
                {onClick: e => (window.location.href = '/#/access/' + event.order.accessId)},
                  <a href={'/#/access/' + event.order.accessId} className='table-link'><i className='fa fa-folder-open-o' /></a>,
                  event.event,
                  event.order.service,
                  event.order.message,
                  event.timestamp,
                  event.order.operation,
                  (event.order.state === 'DONE_SUCCESS' ? <span><i className='fa fa-fw fa-check-circle text-success' /> {event.order.state}</span> : <span><i className='fa fa-fw fa-times-circle text-danger ' /> {event.order.state}</span>)
                ])}>
              <tr>
                <th className='buttons' />
                <th className='buttons'>Event ID</th>
                <th>Service</th>
                <th>Message</th>
                <th>Time</th>
                <th>Operation</th>
                <th>State</th>
              </tr>
            </FlowTable>
          </StaticBox>
        </div>
      </div>
    )
  }
}
//eslint-disable-next-line
OrderEventsOverview = connect(state => state.siteReducer)(OrderEventsOverview)
export default OrderEventsOverview



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.3/orderevents/overview.js